import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useSidebar } from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';

/**
 * Circular toggle that rides the sidebar's right edge (half outside the panel).
 * Collapses the sidebar to its 3rem icon rail and back. Hidden on mobile, where
 * the sidebar is a Sheet driven by its own trigger. Chevron flips with state.
 */
export function SidebarCollapseButton({ className }: { className?: string }) {
  const { state, toggleSidebar } = useSidebar();
  const collapsed = state === 'collapsed';
  const Icon = collapsed ? ChevronRight : ChevronLeft;
  return (
    <button
      type="button"
      aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      onClick={toggleSidebar}
      className={cn(
        // Sits on the seam where the sidebar's right edge meets the bottom of
        // the h-12 header — centered on that 48px line, half outside the panel.
        'absolute top-12 -right-3 z-20 hidden size-6 -translate-y-1/2 items-center justify-center rounded-full border border-border bg-background text-muted-foreground shadow-sm transition-all hover:text-foreground hover:shadow-md md:flex',
        className,
      )}
    >
      <Icon className="size-3.5" />
    </button>
  );
}
